// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Jpi9","filesListContainer":"PosDisputesFiles_filesListContainer__HOzPo","filesButton":"PosDisputesFiles_filesButton__c9H6t"};